var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15.831C11.9162 15.831 9.39625 13.1822 9.39625 9.93784C9.39625 6.69352 11.9162 4 15 4C18.0837 4 20.6037 6.64883 20.6037 9.89315C20.6037 13.1375 18.0837 15.831 15 15.831ZM23.75 27.662H6.25C5.5625 27.662 5 27.0704 5 26.3474V25.0329C5 22.1408 7.25 19.7746 10 19.7746H20C22.75 19.7746 25 22.1408 25 25.0329V26.3474C25 27.0704 24.4375 27.662 23.75 27.662Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.69637ad5a0bf3b2367564bb548aa0b09.svg";
export { ForwardRef as ReactComponent };